import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { AppConfigService } from "../../appconfigservice";
import { ChapterInformation } from "../../config";

@Component({
  selector: 'app-comic',
  templateUrl: './comic.component.html',
  styleUrls: ['./comic.component.sass']
})
export class ComicComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private appConfigService: AppConfigService) { }

  imageLink : string;

  imagePath : string = "../../../assets/";
  chapterTag: string = "Chapter_";
  imageTag : string = "Page_";
  imageNumber: number;
  imageFileFormat: string = ".png";
  maxPage : number;
  chapterInformation : Map<string, ChapterInformation>;
  chapterNumber : number;
  latestPage : number;
  latestChapter : number;

  ngOnInit(): void {
    var comicId = this.route.snapshot.paramMap.get('comicid');
    this.chapterNumber = parseInt(comicId);
    console.log(comicId);
    this.appConfigService.chapters$.subscribe(data => 
    {
      this.chapterInformation = data;
      this.onPageReload();
    });
  }

  onPageReload(){
    this.maxPage =  parseInt(this.chapterInformation?.get(this.chapterNumber.toString())?.numberOfPages);
    this.latestChapter = this.appConfigService.latestChapter$;
    this.latestPage = this.appConfigService.latestPage$;
    this.getPageIdFromQueryString();
    this.imageLink = this.constructImageLink();
  }

  onPageSelectChange(pageNumber) {
    this.router.navigate(['/comic/'+this.chapterNumber+'/page/'+ pageNumber]);
  }

  onNextChapter(){
    var chapterNumberAsNumber : number = this.chapterNumber;
    chapterNumberAsNumber++;
    this.chapterNumber = chapterNumberAsNumber;
    var nextChaper = this.chapterInformation.get(this.chapterNumber.toString());
    if(nextChaper == undefined){
      this.router.navigate(['/']);
    }else{
      this.router.navigate(['/comic/'+(chapterNumberAsNumber)+'/page/'+ 1]);
      this.onPageReload();
    }
  }

  onLeft(){
    if(this.showPrevious()){
      this.router.navigate(['/comic/'+this.chapterNumber+'/page/'+ (this.imageNumber-1)]);
    }
  }

  onRight(){
    if(this.showNext()){
      this.router.navigate(['/comic/'+this.chapterNumber+'/page/'+ (this.imageNumber+1)]);
    }
  }

  getComicIdFromQueryString(){
    var id = this.route.snapshot.paramMap.get('comicid');
    this.route.paramMap.subscribe(queryParams => {
      this.assignId(+queryParams.get("comicid"))
      this.imageLink = this.constructImageLink();
      window.scrollTo(0, 0)
    })
  }

  getPageIdFromQueryString(){
    var id = this.route.snapshot.paramMap.get('pageid');
    var comicId = this.route.snapshot.paramMap.get('comicid');
    this.assignId(+id);
    this.assignComicId(comicId);
    this.route.paramMap.subscribe(queryParams => {
      this.assignId(+queryParams.get("pageid"))
      this.assignComicId(queryParams.get("comicid"));
      this.imageLink = this.constructImageLink();
      window.scrollTo(0, 0)
    })
  }

  getPageNumbers(){
    var pageNums = [];
    for(var i = this.maxPage; i > 0; i--){
      pageNums.push(i);
    }
    return pageNums;
  }

  showPrevious() : boolean{
    return this.imageNumber > 1;
  }

  
  showNext() : boolean{
    return this.imageNumber < this.maxPage;
  }

  assignComicId(id)
  {
    this.chapterNumber = id;
  }

  onChange(value){
    this.router.navigate(['/comic/'+value+'/page/'+ 1]);
    this.chapterNumber = value;
    this.onPageReload();
  }

  assignId(id){
    if(id != undefined){
      this.imageNumber = id;
    }else{
      this.imageNumber = 1;
    }
  }

   constructImageLink() : string  
    {
      if(this.chapterNumber == 0)
      {
        //Pilot
        return this.imagePath + this.imageTag + this.imageNumber + this.imageFileFormat;
      }
      return this.imagePath + this.chapterTag + this.chapterNumber + "_" + this.imageTag + this.imageNumber + this.imageFileFormat;
    }

}
